import TicketCard from "@/Components/BulkSale/TicketCard";
import Authenticated from "@/Layouts/Authenticated";
import { Head } from "@inertiajs/inertia-react";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useEffect, useMemo, useState } from "react";
import Button from "@/Components/Button";
import Input from "@/Components/Input";
import Label from "@/Components/Label";
import { Inertia } from "@inertiajs/inertia";
import Swal from "sweetalert2";

const Tickets = ({ bulkOrders, store, bulkSale, ...props }) => {
    const [enabledCancelOrders, setEnabledCancelOrders] = useState(false);
    const [enabledRestoreOrders, setEnabledRestoreOrders] = useState(false);
    const [selectedOrders, setSelectedOrders] = useState([]);

    const handleSelect = (id) => {
        setSelectedOrders([...selectedOrders, id]);
    }

    const handleDeselect = (id) => {
        const selectOrdersFiltered = selectedOrders.filter(selectedOrderId => selectedOrderId !== id);
        setSelectedOrders(selectOrdersFiltered);
    }

    const selectAll = () => {
        setSelectedOrders(bulkOrders.map(bulkOrder => bulkOrder.id));
    }

    const deselectAll = () => {
        setSelectedOrders([]);
    }

    const handleChangeSelectAllCheckbox = (event) => {
        if (event.target.checked) {
            selectAll();
        } else {
            deselectAll();
        }
    }

    const customSwal = useMemo(() => {
        return Swal.mixin({
            icon: 'warning',
            buttonsStyling: false,
			showCancelButton: true,
			customClass: {
				cancelButton: 'mx-1 py-2 px-4 mr-2 rounded bg-gray-500 text-white'
			},
			reverseButtons: true,
			confirmButtonText: 'Eliminar',
			cancelButtonText: 'Cancelar'
        })
    }, []);

    const handleCancelOrders = () => {
        customSwal.fire({
            title: '¿Estás seguro de querer anular estos tickets?',
			customClass: {
				confirmButton: 'py-2 px-4 ml-2 rounded bg-red-600 text-white',
			},
			confirmButtonText: 'Eliminar',
        }).then(({ isConfirmed }) => {
            if (isConfirmed) {
                Inertia.post(route('bulk-sales.bulk-orders.cancel', { bulkSale, bulk_order_ids: selectedOrders }));
            }
        })
    }

    const handleRestoreOrders = () => {
        customSwal.fire({
            title: '¿Estás seguro de querer restaurar estos tickets?',
			customClass: {
				confirmButton: 'py-2 px-4 ml-2 rounded bg-green-500 text-white',
			},
			confirmButtonText: 'Restaurar',
        }).then(({ isConfirmed }) => {
            if (isConfirmed) {
                Inertia.post(route('bulk-sales.bulk-orders.restore', { bulkSale, bulk_order_ids: selectedOrders }));
            }
        })
    }

    useEffect(() => {
        if (enabledRestoreOrders || enabledCancelOrders) {
            deselectAll();
        }
    }, [enabledCancelOrders, enabledRestoreOrders])

    return (
        <Authenticated
            store={store}
            auth={props.auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight">Ventas empresa</h2>}
        >
            <ToastContainer />
            <Head title="Ventas empresa" />

            {/* <pre><code>{JSON.stringify(selectedOrders, null, 4)}</code></pre> */}

            <main className="max-w-5xl mx-auto py-4">

                <div className="w-full flex flex-col items-end gap-4 px-2 mb-4">
                    <div className="flex items-center gap-2">
                        {enabledCancelOrders ? (
                            <>
                                <Button type="button" className="bg-red-500" onClick={handleCancelOrders}>Confirmar</Button>
                                <Button type="button" className="bg-gray-400" onClick={() => setEnabledCancelOrders(false)}>Cancelar</Button>
                            </>
                        ) : (
                            <>
                                {!enabledRestoreOrders && (
                                    <Button type="button" className="bg-red-500" onClick={() => {
                                        setEnabledCancelOrders(true);
                                        setEnabledRestoreOrders(false);
                                    }}>Anular tickets</Button>
                                )}
                            </>
                        )}

                        {enabledRestoreOrders ? (
                            <>
                                <Button type="button" className="bg-green-500" onClick={handleRestoreOrders}>Confirmar</Button>
                                <Button type="button" className="bg-gray-400" onClick={() => setEnabledRestoreOrders(false)}>Cancelar</Button>
                            </>
                        ) : (
                            <>
                                {!enabledCancelOrders && (
                                    <Button type="button" className="bg-green-500" onClick={() => {
                                        setEnabledRestoreOrders(true);
                                        setEnabledCancelOrders(false);
                                    }}>Restaurar tickets</Button>
                                )}
                            </>
                        )}
                    </div>

                    {(enabledCancelOrders || enabledRestoreOrders) && (
                        <div className="flex items-center gap-2">
                            <Input
                                id="select-all-checkbox"
                                type="checkbox"
                                handleChange={handleChangeSelectAllCheckbox}
                            />
                            <Label
                                forInput="select-all-checkbox"
                                value="Seleccionar todo"
                            />
                        </div>
                    )}

                </div>

                <div className="grid grid-cols-1 gap-4">
                    {bulkOrders.map((bulkOrder, index) => (
                        <TicketCard
                            bulkSale={bulkSale}
                            onSelect={handleSelect}
                            onDeselect={handleDeselect}
                            enabledCancelOrders={enabledCancelOrders}
                            enabledRestoreOrders={enabledRestoreOrders}
                            selected={selectedOrders.some(selectedOrderId => selectedOrderId === bulkOrder.id)}
                            {...bulkOrder}
                        />
                    ))}
                </div>
            </main>
        </Authenticated>
    );
};

export default Tickets;
